"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeWorkflow = exports.continueWorkflow = exports.backWorkflow = void 0;
var _SecureClient = require("../../api/SecureClient");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
var _UnauthenticatedClient = require("./UnauthenticatedClient");
const getHttp = () => {
  if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
    return new _SecureClient.SecureClient();
  }
  return new _UnauthenticatedClient.UnauthenticatedClient();
};
const process = (fullUrl, body) => new Promise((resolve, reject) => {
  const client = getHttp();
  client.postBody(fullUrl, JSON.stringify(body)).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});
const initializeWorkflow = (apiUrl, formData) => new Promise((resolve, reject) => {
  const client = getHttp();
  client.postFormData(`${apiUrl}/initialize`, formData).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});
exports.initializeWorkflow = initializeWorkflow;
const continueWorkflow = (apiUrl, body) => process(`${apiUrl}/continue`, body);
exports.continueWorkflow = continueWorkflow;
const backWorkflow = (apiUrl, body) => process(`${apiUrl}/back`, body);
exports.backWorkflow = backWorkflow;
//# sourceMappingURL=WorkflowAPI.js.map